import { StepConnector, type StepConnectorProps } from '@packages/shared';
import { iconSize } from '../config';

export type ConnectorProps = StepConnectorProps;

export const Connector = ({ sx, ...rest }: ConnectorProps) => (
  <StepConnector
    {...rest}
    sx={{
      ...sx,

      ml: [0, 0, `${iconSize / 2}rem`],
    }}
  />
);
